@if (data) {
  <div class="custom-snackbar">
    <div class="content">
      <div class="bar" [ngClass]="data.type"></div>
      <p>{{ data.message }}</p>
    </div>
    <button mat-icon-button class="close-snackbar-btn" (click)="onClose($event)">
      <app-icon name="close" colour="#84AAFC" />
    </button>
  </div>
}
